export const INCOME_SOURCES = [
  { value: 'Salary', label: 'Salary' },
  { value: 'Business', label: 'Business' },
  { value: 'Freelance', label: 'Freelance' },
  { value: 'Investment', label: 'Investment' },
  { value: 'Pension', label: 'Pension' },
  { value: 'Other', label: 'Other' },
];

export const CURRENCIES = [
  { value: 'INR', label: 'Indian Rupee (₹)', symbol: '₹' },
  { value: 'USD', label: 'US Dollar ($)', symbol: '$' },
  { value: 'EUR', label: 'Euro (€)', symbol: '€' },
  { value: 'GBP', label: 'British Pound (£)', symbol: '£' },
  { value: 'CAD', label: 'Canadian Dollar ($)', symbol: 'CA$' },
  { value: 'AUD', label: 'Australian Dollar ($)', symbol: 'A$' },
];

export const LANGUAGES = [
  { value: 'en', label: 'English' },
  { value: 'hi', label: 'Hindi' },
  { value: 'es', label: 'Spanish' },
  { value: 'fr', label: 'French' },
  { value: 'de', label: 'German' },
];

export const ONBOARDING_STEPS = [
  { id: 1, title: 'Basic Info', description: 'Setup your account' },
  { id: 2, title: 'Financial Info', description: 'Tell us about your finances' },
  { id: 3, title: 'Preferences', description: 'Customize your experience' },
];